import { Context } from "@nuxt/types/app";

import getColourDashboard from "./ui.colourDashboard.plugin";
import getDefineSidebarMenuVisibility from "./ui.defineSidebarMenuVisibility.plugin";
import getGetDeviceOS from "./ui.getDeviceOS.plugin";
import getGetGridList from "./ui.getGridList.plugin";
import getIsMobileView from "./ui.isMobileView.plugin";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function uiPlugin(context: Context) {
  const { colourDashboard } = getColourDashboard(context);
  const { getGridList } = getGetGridList(context);
  const { isMobileView } = getIsMobileView(context);
  const { getDeviceOS } = getGetDeviceOS(context);
  const { defineSidebarMenuVisibility } =
    getDefineSidebarMenuVisibility(context);

  return {
    colourDashboard,
    getGridList,
    isMobileView,
    getDeviceOS,
    defineSidebarMenuVisibility,
  };
}
